<template>
    <div v-if="$store.state.user" :style="style">
        <v-row no-gutters>
            <v-col v-if="hasMembershipAddon" cols="6" class="pl-4">
                <div class="mt-2 text-caption"><v-icon :style="style" small>mdi-wallet-membership</v-icon><span class="text-uppercase ml-1" v-text="$translate('Membership')" /></div>
                <div></div>
                <div v-if="membership" v-text="membership.cardtype_name"></div>
            </v-col>
            <v-col :cols="hasMembershipAddon ? 6 : 12" class="pl-4">
                <div class="text-uppercase text-caption mt-2"><v-icon :style="style" small class="mr-1 mt-n1">mdi-ticket</v-icon><span v-if="validTrainingCards.length > 1">{{validTrainingCards.length}}&nbsp;</span><span v-text="$translate('Training cards')" /></div>
                <div v-if="validTrainingCards.length == 1" class="font-weight-bold text-truncate">{{validTrainingCards[0].cardtype_name}}</div>
                <v-menu v-else-if="validTrainingCards.length > 1">
                    <template #activator="{on}">
                        <div v-on="on" class="z-clickable">
                            {{validTrainingCards[0].cardtype_name}} + {{validTrainingCards.length - 1}} till<v-icon :style="style">mdi-chevron-down</v-icon>
                        </div>
                    </template>

                    <v-list>
                        <v-list-item v-for="card in validTrainingCards" :key="card.id">
                            {{card.cardtype_name}}
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-col>
        </v-row>
    </div>
    <div v-else></div>
</template>

<script>
export default {
    name: 'zoezi-mytrainingcards',

    zoezi: {
        title: 'My training cards',
        icon: 'mdi-card-bulleted-outline'
    },

    computed: {
        hasMembershipAddon() {
            return this.$store.state?.settings?.membership;
        },
        membership() {
            let cards = this.$store.state.cards;
            if (!cards) {
                return null;
            }
            return this.$store.state.cards.find(card => card.membership && this.$booking.isCardValid(card, this.$store.state.now30s.clone().clearTime()));
        },
        validTrainingCards() {
            let cards = this.$store.state.cards;
            return cards ? this.$store.state.cards.filter(card => !card.membership && this.$booking.isCardValid(card, this.$store.state.now30s.clone().clearTime())) : [];
        },
        style() {
            return {'background-color': this.$root.siteconfig.appbar.props.backgroundColor, color: this.$root.siteconfig.appbar.props.color };
        }
    }
}
</script>
